import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'

import ListGroup from 'react-bootstrap/ListGroup'

import Layout from '../../../components/layout'
import PDFsNav from '../../../components/pdfs-nav'
import LookingForMore from '../../../components/looking-for-more'
import ResourcesNav from '../../../components/resources-nav'

export default class Posters extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const resources = get(this, 'props.data.allContentfulResource.edges')
    const metaDescription = `Strategy Posters PDFs for teaching Math in PreK, Kindergarten, Elementary. Free teaching resources from ${siteTitle}`
    return (
      <Layout pageTitle="Posters" description={metaDescription}>
        <ResourcesNav path={this.props.path} />
        <PDFsNav path={this.props.path} />
        <h1>Strategy Posters</h1>
        <ListGroup>
          {resources.map(
            ({ node }, i) =>
              node.file && (
                <ListGroup.Item key={i} as="a" href={node.file.file.url}>
                  {node.title}
                </ListGroup.Item>
              )
          )}
        </ListGroup>
        <hr />
        <LookingForMore />
      </Layout>
    )
  }
}

export const Query = graphql`
  query PostersQuery {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulResource(
      filter: { collections: { eq: "poster-pdfs" } }
      sort: { fields: createdAt }
    ) {
      edges {
        node {
          slug
          title
          file {
            file {
              url
            }
          }
        }
      }
    }
  }
`
